"use client";

import { EndpointContext } from "@/graphql/client";

interface Props {
  endpoint: string;
  children: React.ReactNode;
}

export const Providers: React.FunctionComponent<Props> = ({ endpoint, children }) => {
  return <EndpointContext.Provider value={endpoint}>{children}</EndpointContext.Provider>;
};
